import * as React from 'react';
import { NoNavigationPageWrapper } from '../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { PublicPageProvider } from '../_contexts/PublicPageContext';
import { PasswordResetPanel } from './_components/PasswordResetPanel';

export default function RequestPasswordSetupPage (): JSX.Element
{
    return (
        <PublicPageProvider>
            <NoNavigationPageWrapper>

                <PasswordResetPanel
                    header='Opret adgangskode'
                    helpText='Indtast navnet på din organisation og din e-mail. Så sender vi dig vejledning i at oprette en adgangskode.'
                    isSetup
                />

            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}